import React, { useState, useEffect } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    Chip,
    Checkbox,
    ListItemText,
    InputAdornment
} from "@mui/material"
import { Form, sxBoxRenderValue, sxChipSelect, sxSelect } from "./SxRondaSelect"
import { KeyboardArrowDown, Search } from "@mui/icons-material"

const RondaSelect = ({ options, defaultValue, label = "descricao", setObjEnviado, entradaMonitoradaEdit, rest }) => {
    const [selected, setSelected] = useState(defaultValue || [])

    useEffect(() => {
        let ids = []
        if (selected && selected.length > 0) {
            ids = selected.map(s => { return s.id })
        }
        setObjEnviado((prevState) => ({
            ...prevState,
            entrada_escolhida: ids
        }))
    }, [selected])

    return (
        <Box>
            {options && (

                <FormControl sx={Form}>
                    <Select
                        name={name}
                        multiple
                        sx={sxSelect}
                        value={selected}
                        onChange={(event) => { setSelected(event.target.value) }}
                        renderValue={(selected) => (
                            <Box sx={sxBoxRenderValue}>
                                {selected.map((value, index) => (
                                    <Chip
                                        sx={sxChipSelect}
                                        key={index}
                                        label={value[label]}
                                    />
                                ))}
                            </Box>
                        )}
                        inputProps={{
                            sx: { padding: '0 5px' }
                        }}
                        labelId="search-select-label"
                        IconComponent={KeyboardArrowDown}
                        id="ronda_entradas_select"
                        onClose={() => {}}
                        {...rest}
                    >
                        <ListSubheader>
                            <TextField
                                size="small"
                                autoFocus
                                placeholder="Pesquisar..."
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    )
                                }}
                                onChange={(e) => {}}
                                onKeyDown={(e) => {
                                    if (e.key !== "Escape") {
                                        e.stopPropagation()
                                    }
                                }}
                            />
                        </ListSubheader>
                        <MenuItem key="menu_combo_vazio" value="" onClick={() => setTimeout(() => setSelected([]), 10)}>
                            Remover Seleção
                        </MenuItem>
                        {options.map((option, i) => (
                            <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option}>
                                <Checkbox checked={selected.some(el => el.id == option.id)} />
                                <ListItemText primary={option.descricao} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </Box>
    )
}

export default RondaSelect
